import React, { Component } from 'react';
import './index.less';
class ReactCarousel extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      imgs: [
        [
          '/assets/1.png',
          '/assets/2.png',
          '/assets/3.png',
          '/assets/4.png',
          '/assets/5.png',
          '/assets/6.png',
        ],
        [
          '/assets/7.png',
          '/assets/8.png',
          '/assets/9.png',
          '/assets/10.png',
          '/assets/11.png',
          '/assets/12.png',
        ],
        [
          '/assets/13.png',
          '/assets/14.png',
          '/assets/15.png',
          '/assets/16.png',
          '/assets/17.png',
        ]
      ],   // 图片数组
      showIndex: 0, //显示第几个图片
      timer: null,  // 定时器
      show: false   // 前后按钮显示
    }
  }
  componentDidMount() { //一开始自动播放
    this.start();
  }
  componentWillUnmount() { //销毁前清除定时器
    this.stop();
  }
  stop = () => { //暂停
    let { timer } = this.state;
    clearInterval(timer);
  }
  start = () => { //开始
    console.log("start");
    
    let { timer } = this.state;
    timer = setInterval(() => {
      this.next();
    }, 10000);
    this.setState({
      timer
    })
  }
  change = (index) => { //点击下面的按钮切换当前显示的图片
    let { showIndex } = this.state;
    showIndex = index;
    this.setState({
      showIndex
    })
  }
  previous = (e) => { //上一张
    let ev = e || window.event;
    let { showIndex, imgs } = this.state;
    if (showIndex <= 0) {
      showIndex = imgs.length - 1;
    } else {
      showIndex--;
    }
    this.setState({
      showIndex
    })
  }
  next = (e) => { //下一张
    console.log("下一章");
    
    let ev = e || window.event;
    let { showIndex, imgs } = this.state;
    if (showIndex >= imgs.length - 1) {
      showIndex = 0;
    } else {
      showIndex++;
    }
    this.setState({
      showIndex
    })
  }
  

  render() {
    return (
      // <div className="ReactCarousel">

        <div className="contain"
          onMouseEnter={() => { this.stop() }} //鼠标进入停止自动播放
          onMouseLeave={() => { this.start() }}  //鼠标退出自动播放
        >
          <ul className="ul">
            {
              this.state.imgs.map((value, index) => {
                return (
                  <li className={index === this.state.showIndex ? 'show' : ''}
                    key={index}
                  >
                    <div>
                      {
                        value.map((item, i) => {
                          return (
                            // <div key={i}>
                              <img src={item} alt="轮播图" />
                            // </div>
                          )
                        })
                      }
                    </div>
                  </li>
                )
              })
            }
          </ul>
          <ul className="dots" style={{ width: this.state.imgs.length * 20 + 'px' }}>
            {
              this.state.imgs.map((value, index) => {
                return (
                  <li key={index}
                    className={index === this.state.showIndex ? 'active' : ''}
                    onClick={() => { this.change(index) }}>
                  </li>)
              })
            }

          </ul>
          {/* <div className="control">
            <span className="left" onClick={(e) => { this.previous(e) }}>左</span>
            <span className="right" onClick={(e) => { this.next(e) }}>右</span>
          </div> */}
          {/* </div> */}
        </div>
    )
  }
  
}
export default ReactCarousel;